const LanguageLable = {
  languageLable: 'Language Lable',
  addLanguageLable: 'Add Language Lable',
  editLanguageLable: 'Edit Language Lable',
};
export default LanguageLable;
